module.exports = "/static/js/abb62612f90693f9e723215a782f42da.png";